<div class="flex flex-col gap-6">
  <span class="text-[18px] font-bold">Datos economicos</span>

  <div class="grid grid-cols-2 gap-8">
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('costBenefitAnalysisCheck')"
        (change)="reviewFields.toggleField('costBenefitAnalysisCheck')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Analisis coste-beneficio realizado</span>
          <app-tooltip
            *ngIf="
              reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('costBenefitAnalysisCheck')
            "
            class="-mt-2"
            [description]="previousReviewText('costBenefitAnalysisCheck')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular">
          {{ economicData?.costBenefitAnalysisCheck ? 'Si' : 'No' }}
        </span>
      </div>
    </div>

    <div
      *ngIf="economicData?.csvCostBenefit"
      class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('csvCostBenefit')"
        (change)="reviewFields.toggleField('csvCostBenefit')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">CSV (Codigo identificador del documento)</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('csvCostBenefit')"
            class="-mt-2"
            [description]="previousReviewText('csvCostBenefit')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular">
          {{ economicData?.csvCostBenefit }}
        </span>
      </div>
    </div>
  </div>

  <div
    *ngIf="economicData?.costBenefitAnalysisCheck"
    class="flex gap-3 items-start">
    <input
      *ngIf="reviewMode && !readonlyReview"
      type="checkbox"
      class="mt-1"
      [checked]="reviewFields.isFieldMarked('costBenefitAnalysis')"
      (change)="reviewFields.toggleField('costBenefitAnalysis')" />
    <div class="flex flex-col gap-2">
      <div class="flex items-start gap-2">
        <span class="text-[14px] text-neutral-dark">Descripcion del analisis coste-beneficio</span>
        <app-tooltip
          *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('costBenefitAnalysis')"
          class="-mt-2"
          [description]="previousReviewText('costBenefitAnalysis')"
          tipeIcon="info"></app-tooltip>
      </div>
      <span class="text-[16px] font-regular whitespace-pre-line">
        {{ economicData?.costBenefitAnalysis || '-' }}
      </span>
    </div>
  </div>
</div>
